import React from 'react';
import {Atom, Plugins, withMeta, withSystem} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
} from '@packages/utilities/data-utils';

const TabsMenu = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => {
    const Tag = getInPojo(data, ['tag']) as React.ElementType;
    const tabsMenuClasses = classes.push('w-tab-menu');
    return (
      <Tag {...generateAttributes(attributes, tabsMenuClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, context)
        )}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Tabs Menu',
  constraints: {
    parent: [
      {
        is: 'TabsWrapper',
        rule: 'ExactlyOne',
      },
    ],
    children: [
      {
        is: 'TabsLink',
        name: 'Non-Tab-Link Item',
        rule: 'RequireOnly',
      },
      {
        is: 'TabsLink',
        rule: 'AtLeastOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Tabs'), iconName('TabsMenu')),
  },
  showEmpty: true,
  render: TabsMenu,
  fields: {
    tag: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'div',
          label: 'Tag',
          private: true,
        },
        TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
      )
    ),
    children: TListOfElement,
  },
});

export default config;
